import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoGarantiaModalidad } from '../_models/requisito-garantia-modalidad';

@Injectable({
  providedIn: 'root'
})
export class RequisitoGarantiaModalidadService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasModalidades';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as RequisitoGarantiaModalidad[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as RequisitoGarantiaModalidad[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as RequisitoGarantiaModalidad ) );
  }

  listadoPorIdRequisito( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id ).pipe( map( res => res as RequisitoGarantiaModalidad[] ) );
  }

  listadoPorIdRequisitoHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id  + '/enabled').pipe( map( res => res as RequisitoGarantiaModalidad[] ) );
  }

  crear( regCrear: RequisitoGarantiaModalidad ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as RequisitoGarantiaModalidad ) );
  }

  bulk( regCrear: RequisitoGarantiaModalidad[] ) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map( x => {
      x.auditoriaUsuario = auditoriaUsuario;
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as RequisitoGarantiaModalidad[] ) );
  }

  actualizar( regActualizar: RequisitoGarantiaModalidad ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as RequisitoGarantiaModalidad ) );
  }
}
